import React, { useEffect } from 'react';
import { Box, Hidden } from '@material-ui/core';
import Typed from 'typed.js';
import musafirbazarlogo from '../../assets/images/musafirbazarlogo.png';
import featured from '../../assets/images/featured-reo-de-janeiro-brazil.jpg';
import featuredaustralia from '../../assets/images/featured-north-bondi-australia.jpg';
import featuredgermany from '../../assets/images/featured-berlin-germany.jpg';
import featuredthailand from '../../assets/images/featured-khwaeng-wat-arun-thailand.jpg';
import featureditaly from '../../assets/images/featured-rome-italy.jpg';
import featuredmaldives from '../../assets/images/featured-fuvahmulah-maldives.jpg';
import header from '../../assets/images/header-bg.jpg';
import service from '../../assets/images/header-bg.jpg';
import './Homepage2.css';
import test1 from '../../assets/images/test-1.jpg';
import test2 from '../../assets/images/test-2.jpg';
import test3 from '../../assets/images/avt.jpg';
import SearchFlightNew from '../../form/SearchFlightNew';
import flightnew from '../../assets/images/flightnew.svg';
import trainnew from '../../assets/images/trainnew.svg';
import busnew from '../../assets/images/busnew.svg';
import hotelnew from '../../assets/images/hotelnew.svg';
import TitleText from '../../components/reusableComponents/TitleText';
import { useDispatch } from 'react-redux';
import { fetchBannerDispatch } from '../../reducers/BannerReducer';
import { fetchCityDispatch } from '../../reducers/HomeReducer';
import SearchBus2 from '../../form/SearchBus2';
import { useHistory } from 'react-router-dom';
const BusPage2 = () => {
	const dispatch = useDispatch();
	const el = React.useRef(null);
	const typed = React.useRef(null);
	React.useEffect(() => {
		const options = {
			strings: ['Welcome to <strong>Musafirbazar</strong>', 'Book Bus Tickets'],
			typeSpeed: 100,
			backSpeed: 100,
			loop: true,
		};

		typed.current = new Typed(el.current, options);
	}, []);
	const history = useHistory();
	useEffect(() => {
		dispatch(fetchBannerDispatch());
		dispatch(fetchCityDispatch());
	}, []);
	return (
		<>
			<nav className='navbar'>
				<div className='container flex'>
					<a href='index.html' className='site-brand'>
						<img
							src={musafirbazarlogo}
							style={{ width: 300, display: 'block' }}></img>
					</a>

					<Hidden only={['xs']}>
						<Box display='flex'>
							<Box
								display='flex'
								alignItems='center'
								onClick={() => history.push('/new')}>
								<img
									src={flightnew}
									style={{ borderRadius: 25, background: 'white' }}></img>
								<TitleText four textStyle={{ color: 'white' }}>
									Flights
								</TitleText>
							</Box>
							<Box display='flex' alignItems='center' ml={'30px'}>
								<img
									src={trainnew}
									style={{ borderRadius: 25, background: 'white' }}></img>
								<TitleText four textStyle={{ color: 'white', marginLeft: 10 }}>
									Trains
								</TitleText>
							</Box>
							<Box
								display='flex'
								alignItems='center'
								ml={'30px'}
								onClick={() => history.push('/bus2')}>
								<img
									src={busnew}
									style={{
										filter:
											' invert(46%) sepia(45%) saturate(4226%) hue-rotate(348deg) brightness(96%) contrast(91%)',
										borderRadius: 25,
									}}></img>
								<TitleText four textStyle={{ color: 'white', marginLeft: 10 }}>
									Buses
								</TitleText>
							</Box>
							<Box display='flex' alignItems='center' ml={'30px'}>
								<img
									src={hotelnew}
									style={{ borderRadius: 25, background: 'white' }}></img>
								<TitleText four textStyle={{ color: 'white', marginLeft: 10 }}>
									Hotels
								</TitleText>
							</Box>
						</Box>
					</Hidden>
				</div>
			</nav>
			<header
				className='flex'
				style={{
					backgroundImage: `url(${header})`,
					minHeight: '100vh',
					// paddingTop: '7rem',
				}}>
				<div className='container'>
					<div className='header-title'>
						<h1
							ref={el}
							style={{
								fontSize: '3em',
								margin: '0.67em 0',
								textAlign: 'center',
								color: 'white',
							}}></h1>
					</div>
					<div className='header-form'>
						<SearchBus2 />
					</div>
				</div>
			</header>
			<section id='featured' className='py-4'>
				<div className='container'>
					<div className='title-wrap'>
						<span className='sm-title' style={{ fontSize: '2rem' }}>
							know about some places before your travel
						</span>
						<h2 className='lg-title' style={{ fontSize: '2rem' }}>
							featured places
						</h2>
					</div>

					<div className='featured-row'>
						<div className='featured-item my-2 shadow'>
							<img
								src={featured}
								alt='featured place'
								style={{ width: '100%', display: 'block' }}
							/>
							<div className='featured-item-content'>
								<span>
									<i className='fas fa-map-marker-alt'></i>
									Reo De Janeiro, Brazil
								</span>
								<div>
									<p className='text'>
										Lorem ipsum, dolor sit amet consectetur adipisicing elit.
										Dicta sed dignissimos libero soluta illum, harum amet
										excepturi sit?
									</p>
								</div>
							</div>
						</div>

						<div className='featured-item my-2 shadow'>
							<img
								src={featuredaustralia}
								alt='featured place'
								style={{ width: '100%', display: 'block' }}
							/>
							<div className='featured-item-content'>
								<span>
									<i className='fas fa-map-marker-alt'></i>
									North Bondi, Australia
								</span>
								<div>
									<p className='text'>
										Lorem ipsum, dolor sit amet consectetur adipisicing elit.
										Dicta sed dignissimos libero soluta illum, harum amet
										excepturi sit?
									</p>
								</div>
							</div>
						</div>

						<div className='featured-item my-2 shadow'>
							<img
								src={featuredgermany}
								alt='featured place'
								style={{ width: '100%', display: 'block' }}
							/>
							<div className='featured-item-content'>
								<span>
									<i className='fas fa-map-marker-alt'></i>
									Berlin, Germany
								</span>
								<div>
									<p className='text'>
										Lorem ipsum, dolor sit amet consectetur adipisicing elit.
										Dicta sed dignissimos libero soluta illum, harum amet
										excepturi sit?
									</p>
								</div>
							</div>
						</div>

						<div className='featured-item my-2 shadow'>
							<img
								src={featuredthailand}
								alt='featured place'
								style={{ width: '100%', display: 'block' }}
							/>
							<div className='featured-item-content'>
								<span>
									<i className='fas fa-map-marker-alt'></i>
									Khwaeng wat arun, thailand
								</span>
								<div>
									<p className='text'>
										Lorem ipsum, dolor sit amet consectetur adipisicing elit.
										Dicta sed dignissimos libero soluta illum, harum amet
										excepturi sit?
									</p>
								</div>
							</div>
						</div>

						<div className='featured-item my-2 shadow'>
							<img
								src={featureditaly}
								alt='featured place'
								style={{ width: '100%', display: 'block' }}
							/>
							<div className='featured-item-content'>
								<span>
									<i className='fas fa-map-marker-alt'></i>
									Rome, Italy
								</span>
								<div>
									<p className='text'>
										Lorem ipsum, dolor sit amet consectetur adipisicing elit.
										Dicta sed dignissimos libero soluta illum, harum amet
										excepturi sit?
									</p>
								</div>
							</div>
						</div>

						<div className='featured-item my-2 shadow'>
							<img
								src={featuredmaldives}
								alt='featured place'
								style={{ width: '100%', display: 'block' }}
							/>
							<div className='featured-item-content'>
								<span>
									<i className='fas fa-map-marker-alt'></i>
									fuvahmulah, maldives
								</span>
								<div>
									<p className='text'>
										Lorem ipsum, dolor sit amet consectetur adipisicing elit.
										Dicta sed dignissimos libero soluta illum, harum amet
										excepturi sit?
									</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			<section
				id='servicess'
				className='py-4'
				style={{ backgroundImage: `url(${service})` }}>
				<div className='container'>
					<div className='title-wrap'>
						<span className='sm-title' style={{ fontSize: '2rem' }}>
							know about services that we offer
						</span>
						<h2 className='lg-title' style={{ fontSize: '2rem' }}>
							Our services
						</h2>
					</div>

					<div className='services-row'>
						<div className='services-item'>
							<span className='services-icon'>
								<i className='fas fa-hotel'></i>
							</span>
							<h3>Luxurious Hotel</h3>
							<p className='text'>
								Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quidem
								quo, totam repellat velit, dignissimos sequi error a minima
								architecto fugit nisi dolorum repellendus?
							</p>
							<a href='#' className='btn'>
								Read more
							</a>
						</div>

						<div className='services-item'>
							<span className='services-icon'>
								<i className='fas fa-map-marked-alt'></i>
							</span>
							<h3>Trave Guide</h3>
							<p className='text'>
								Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quidem
								quo, totam repellat velit, dignissimos sequi error a minima
								architecto fugit nisi dolorum repellendus?
							</p>
							<a href='#' className='btn'>
								Read more
							</a>
						</div>

						<div className='services-item'>
							<span className='services-icon'>
								<i className='fas fa-money-bill'></i>
							</span>
							<h3>Suitable Price</h3>
							<p className='text'>
								Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quidem
								quo, totam repellat velit, dignissimos sequi error a minima
								architecto fugit nisi dolorum repellendus?
							</p>
							<a href='#' className='btn'>
								Read more
							</a>
						</div>
					</div>
				</div>
			</section>
			<section id='testimonials' className='py-4'>
				<div className='container'>
					<div className='title-wrap'>
						<span className='sm-title' style={{ fontSize: 22 }}>
							what our clients say about us
						</span>
						<h2 className='lg-title' style={{ fontSize: 20 }}>
							testimonials
						</h2>
					</div>

					<div className='test-row'>
						<div className='test-item'>
							<p className='text'>
								Lorem ipsum dolor sit amet consectetur adipisicing elit.
								Assumenda blanditiis, asperiores, velit iste eos officiis
								tempora magni quaerat quo consectetur expedita cum recusandae
								facere nam voluptate minus iusto eum. Delectus!
							</p>
							<div className='test-item-info'>
								<img src={test1} alt='testimonial' />
								<div>
									<h3>Kevin Wilson</h3>
									<p className='text'>Trip to Brazil</p>
								</div>
							</div>
						</div>

						<div className='test-item'>
							<p className='text'>
								Lorem ipsum, dolor sit amet consectetur adipisicing elit. Sed ut
								dolores tenetur harum deserunt. Maxime tenetur consectetur
								recusandae nobis fugit iusto natus quibusdam nulla!
							</p>
							<div className='test-item-info'>
								<img src={test2} alt='testimonial' />
								<div>
									<h3>Ben Davis</h3>
									<p className='text'>Trip to Maldives</p>
								</div>
							</div>
						</div>

						<div className='test-item'>
							<p className='text'>
								Lorem ipsum dolor sit, amet consectetur adipisicing elit. Quidem
								sapiente amet expedita quae autem deleniti quo magni numquam
								facilis soluta dicta, praesentium ipsum, quos optio sed
								quibusdam! Reprehenderit recusandae provident id nemo!
							</p>
							<div className='test-item-info'>
								<img src={test3} alt='testimonial' />
								<div>
									<h3>Jaura Jones</h3>
									<p className='text'>Trip to Thailand</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			{/* <section id='video' style={{ padding: 0 }}>
				<div className='video-wrapper flex'>
					<video loop>
						<source src={videos} type='video/mp4' />
					</video>
					<button
						type='button'
						id='play-btn'
						onClick={() => {
							let video = document.querySelector('.video-wrapper video');
							if (video.paused) {
								video.play();
							} else {
								video.pause();
							}
						}}>
						<i className='fas fa-play'></i>
					</button>
				</div>
			</section> */}
			<footer className='py-4'>
				<div className='container footer-row'>
					<div className='footer-item'>
						<a href='index.html' className='site-brand'>
							Musafir<span>Bazar</span>
						</a>
						<p className='text'>
							Lorem ipsum dolor sit amet consectetur adipisicing elit. Eveniet
							voluptates maiores nam vitae iusto. Placeat rem sint voluptas
							natus exercitationem autem quod neque, odit laudantium reiciendis
							ipsa suscipit veritatis voluptate.
						</p>
					</div>

					<div className='footer-item'>
						<h2>Follow us on: </h2>
						<ul className='social-links'>
							<li>
								<a
									href='https://www.facebook.com/musafirbazaar'
									target='_blank'>
									<i className='fab fa-facebook-f'></i>
								</a>
							</li>
							<li>
								<a
									href='https://www.instagram.com/musafirbazar/'
									target='_blank'>
									<i className='fab fa-instagram'></i>
								</a>
							</li>
							<li>
								<a href='https://twitter.com/musafirbazar' target='_blank'>
									<i className='fab fa-twitter'></i>
								</a>
							</li>
							<li>
								<a href='#'>
									<i className='fab fa-pinterest'></i>
								</a>
							</li>
							<li>
								<a href='#'>
									<i className='fab fa-google-plus'></i>
								</a>
							</li>
						</ul>
					</div>

					<div className='footer-item'>
						<h2>Popular Places:</h2>
						<ul>
							<li>
								<a href='#'>Thailand</a>
							</li>
							<li>
								<a href='#'>Australia</a>
							</li>
							<li>
								<a href='#'>Maldives</a>
							</li>
							<li>
								<a href='#'>Switzerland</a>
							</li>
							<li>
								<a href='#'>Germany</a>
							</li>
						</ul>
					</div>

					<div className='subscribe-form footer-item'>
						<h2>Subscribe for Newsletter!</h2>
						<form className='flex'>
							<input
								type='email'
								placeholder='Enter Email'
								className='form-control'
							/>
							<input type='submit' className='btn' value='Subscribe' />
						</form>
					</div>
				</div>
			</footer>
		</>
	);
};

export default BusPage2;
